
import { Component, Vue, Watch, Prop, VModel } from 'vue-property-decorator';

@Component
export default class TimePicker extends Vue {
    timeMenu = false;
    displayTime = '';

    @VModel() innerValue!: string | null;
    @Prop() label!: string;
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) readonly!: boolean;

    // Časy po půl hodinách pro celý den (00:00 - 23:30)
    timeOptions: string[] = [
        '00:00',
        '00:30',
        '01:00',
        '01:30',
        '02:00',
        '02:30',
        '03:00',
        '03:30',
        '04:00',
        '04:30',
        '05:00',
        '05:30',
        '06:00',
        '06:30',
        '07:00',
        '07:30',
        '08:00',
        '08:30',
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00',
        '18:30',
        '19:00',
        '19:30',
        '20:00',
        '20:30',
        '21:00',
        '21:30',
        '22:00',
        '22:30',
        '23:00',
        '23:30',
    ];

    mounted() {
        this.initializeDisplayTime();
    }

    initializeDisplayTime() {
        if (this.innerValue) {
            // Pokud je formát "06:00:00", extrahujeme "06:00"
            const parts = this.innerValue.split(':');
            if (parts.length >= 2) {
                this.displayTime = `${parts[0]}:${parts[1]}`;
            }
        }
    }

    @Watch('innerValue')
    innerValueChanged() {
        this.initializeDisplayTime();
    }

    @Watch('displayTime')
    displayTimeChanged(newVal: string, oldVal: string) {
        if (newVal === oldVal) return;

        // Validace a automatické formátování
        const raw = (newVal || '').replace(/[^0-9]/g, '');
        if (raw.length === 4 && newVal.indexOf(':') === -1) {
            const hh = raw.substring(0, 2);
            const mm = raw.substring(2, 4);
            if (Number(hh) < 24 && Number(mm) < 60) {
                this.displayTime = `${hh}:${mm}`;
                this.emitValue(`${hh}:${mm}:00`);
                return;
            }
        }

        // Pokud je čas ve formátu HH:mm
        if (newVal && /^\d{2}:\d{2}$/.test(newVal)) {
            const [hh, mm] = newVal.split(':');
            if (Number(hh) < 24 && Number(mm) < 60) {
                this.emitValue(`${hh}:${mm}:00`);
                return;
            }
        }

        // Pokud je prázdný
        if (!newVal || newVal === '') {
            this.emitValue(null);
        }
    }

    selectTime(time: string) {
        this.displayTime = time;
        this.emitValue(`${time}:00`);
        this.timeMenu = false;
    }

    emitValue(value: string | null) {
        this.$emit('input', value);
    }

    get rules(): any[] {
        const rules: any[] = [];
        if (this.required) {
            rules.push((v: any) => !!v || this.$i18n.t('validation.thisFieldIsRequired'));
        }
        rules.push((v: any) => {
            if (!v) return true;
            const timeRegex = /^\d{2}:\d{2}$/;
            if (!timeRegex.test(v)) return this.$i18n.t('validation.invalidTimeFormat') || 'Neplatný formát času';
            const [hh, mm] = v.split(':');
            if (Number(hh) >= 24 || Number(mm) >= 60) {
                return this.$i18n.t('validation.invalidTime') || 'Neplatný čas';
            }
            return true;
        });
        return rules;
    }
}
